import React from 'react';
import classNames from 'classnames';

import './AuthenticationStructure.scss';

const AuthenticationStructure = ({
    children,
    sectionClassName = 'eds-l-pad-vert-14',
    wrapperClassName,
}) => {
    const _sectionClassName = classNames(
        'authentication__structure',
        sectionClassName,
    );

    const gridClasses =
        wrapperClassName ||
        classNames(
            'authentication__structure-wrapper eds-g-cell',
            wrapperClassName,
        );

    return (
        <div className={_sectionClassName}>
            <div className="authentication__structure-content eds-g-group">
                <div className={gridClasses}>{children}</div>
            </div>
        </div>
    );
};

export default AuthenticationStructure;
